import { render } from "./Society.vue?vue&type=template&id=48d9a498"
import script from "./Society.vue?vue&type=script&lang=js"
export * from "./Society.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Society.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48d9a498"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48d9a498', __exports__)) {
    api.reload('48d9a498', __exports__)
  }
  
  module.hot.accept("./Society.vue?vue&type=template&id=48d9a498", () => {
    api.rerender('48d9a498', render)
  })

}


export default __exports__